import React, { useEffect, useState } from 'react';
import EditTool from '../components/EditTool';
import EditingView from '../components/EditView';
import { useMutation } from '@tanstack/react-query';
import { ttsService } from '../services/textToSpeechApi';
import { ArrowLeft, MoreVertical } from 'lucide-react';
import toast from 'react-hot-toast';
import Player from '../components/Player';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

export default function GetStartedPage() {
  const [textInput, setTextInput] = useState('');
  const [lastProcessedText, setLastProcessedText] = useState(''); // Track last processed text
  const [audioUrl, setAudioUrl] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const [isChanged, setIsChanged] = useState('');
  const [button, setButton] = useState(false);
  const navigate = useNavigate();
  const handleDownload = async () => {
    try {
      const response = await fetch(audioUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'generated-audio.mp3';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('Download Complete');
    } catch (error) {
      console.error('Download failed:', error);
      toast.error('Failed to download GIF');
    }
  };
  const mutation = useMutation({
    mutationFn: ttsService.generateVoice,
    onSuccess: (data) => {
      setAudioUrl(data.data);
      setButton(true);
      setLastProcessedText(textInput); // Update last processed text
    },
    onError: (error) => {
      console.error('TTS generation failed:', error);
    },
  });

  const handleConvertToSpeech = async (
    e: React.FormEvent,
    text: string,
    selectedName: string
  ) => {
    e.preventDefault();
    setButton(false);
    if (text.length < 2) {
      toast.error('Please must be more than 2 characters');
      return;
    }
    setAudioUrl('');

    mutation.mutate({
      text: text,
      voice_name: selectedName,
      emotion: 'neutral',
      is_celebrity: false,
    });
  };

  const handleBack = () => {
    setTextInput('');
    setLastProcessedText(''); // Reset last processed text
    setAudioUrl('');
    setIsChanged('');
    setSelectedName('');
    navigate('/text-to-speech/get-started');
  };

  const handleDiscard = () => {
    setTextInput('');
    setLastProcessedText('');
    setAudioUrl('');
    setSelectedName('');
    setIsChanged('');
  };

  useEffect(() => {
    const audioUrl = localStorage.getItem('audioUrl');
    const text = localStorage.getItem('text');
    const selectedName = localStorage.getItem('selectedName');
    const isChanged = localStorage.getItem('selectedName');
    if (audioUrl) {
      setAudioUrl(audioUrl);
      setTextInput(text || '');
      setSelectedName(selectedName || '');
      setIsChanged(isChanged || '');
      // setButton('Regenerate audio');
      setLastProcessedText(localStorage.getItem('text') || '');
      localStorage.removeItem('audioUrl');
      localStorage.removeItem('text');
      localStorage.removeItem('selectedName');
    }
  }, []);

  // Rest of your code remains the same...

  return (
    <div className="flex flex-col md:flex-row h-full w-full overflow-y-auto sm:overflow-hidden gap-4">
      <div className="bg-background-main flex-col relative w-full lg:w-[80%] justify-center  rounded-md">
        <div className="p-2 md:p-3 px-3 md:px-4 border-b flex justify-between items-center gap-2">
          <div className="flex items-center gap-2 pl-2 md:pl-4">
            <p className="text-[24px] font-medium text-text-primary flex justify-center items-center gap-2 md:gap-3">
              <div className="text-primary cursor-pointer" onClick={handleBack}>
                <ArrowLeft size={20} />
              </div>
              Text To Speech
            </p>
          </div>
          <div className="flex justify-end gap-2 items-center">
            {/* Desktop view */}
            <div className="hidden md:flex gap-2">
              <Button
                variant="customSecondary"
                className="bg-secondary text-[14px]"
                onClick={handleDiscard}
              >
                Discard
              </Button>
              {audioUrl !== '' && (
                <button
                  className=" bg-primary text-white px-2 md:px-3 py-1 text-sm md:text-[14px] rounded-md"
                  onClick={handleDownload}
                >
                  Download (.mp3)
                </button>
              )}
            </div>

            {/* Mobile view */}
            <div className="md:hidden">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="h-8 w-8 p-0">
                    <MoreVertical className="h-4 w-4 text-text-primary" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  align="end"
                  className="bg-background text-text-primary"
                >
                  <DropdownMenuItem onClick={handleDiscard}>
                    Discard
                  </DropdownMenuItem>
                  {audioUrl !== '' && (
                    <DropdownMenuItem onClick={handleDownload}>
                      Download (.mp3)
                    </DropdownMenuItem>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>

        <div className="">
          <div className="hidden lg:flex">
            <EditingView textInput={textInput} setTextInput={setTextInput} />
          </div>
          <div className=" flex lg:hidden  flex-col justify-center items-center">
            <div className=" text-primary text-[20px] pt-3 mx-4">
              Welcome to Text to Speech. Add your content to generate speech.
            </div>
            <EditingView textInput={textInput} setTextInput={setTextInput} />
          </div>
        </div>

        {/* <div className="bottom-0 sticky md:absolute w-full md:w-[calc(100%-20px)] mx-0 md:mx-[10px] bg-[#168566] md:bg-transparent p-2 md:p-0 border-t md:border-0">
          {audioUrl && <Player url={audioUrl} />}
        </div> */}
        {audioUrl && (
          <div className="bg-primary  rounded-lg bottom-0 sticky md:absolute w-full md:w-[calc(100%-20px)] mx-0 h-[128px] md:mx-[10px] mb-4  p-2 md:p-3 border-t md:border-0">
            <Player url={audioUrl} />
          </div>
        )}
      </div>

      <EditTool
        // button={button}
        setLastProcessedText={setLastProcessedText}
        isChanged={isChanged}
        setIsChanged={setIsChanged}
        selectedName={selectedName}
        setSelectedName={setSelectedName}
        handleGenerate={handleConvertToSpeech}
        text={textInput}
        lastProcessedText={lastProcessedText} // Pass this to EditTool
      />
    </div>
  );
}
